<div class="nav-pills">
    @for (menu of extendTopMenu() | dsl | async; track $index) {
        <div
            class="pill-item"
            [id]="menu.name"
            [class]="{ active: config().currentUrl == menu.url }"
            [attr.routeUrl]="menu.url"
            (click)="handleGoToUrl(menu.url)"
            (keyup)="handleGoToUrl(menu.url)">
            <cc-pill-item
                [config]="config()"
                [item]="menu"
                [isSelected]="config().currentUrl == menu.url"
                [iconName]="menu.cssClass"
                [currentTheme]="currentTheme()">
            </cc-pill-item>
        </div>
    }
</div>
